export default __webpack_public_path__ + "static/media/black-ks-logo.487bfe77.png";